import { render, staticRenderFns } from "./SignerData.vue?vue&type=template&id=2d2f0fed&scoped=true&"
import script from "./SignerData.vue?vue&type=script&lang=js&"
export * from "./SignerData.vue?vue&type=script&lang=js&"
import style0 from "./SignerData.vue?vue&type=style&index=0&id=2d2f0fed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f0fed",
  null
  
)

export default component.exports